/**
 * variant-image-filter.js   —  Hyper theme (1.3.x)
 *
 * Shows only the gallery images for the selected variant color by REMOVING the
 * other colors' slides from the Swiper on page load. Removing (instead of
 * hiding) keeps the remaining images contiguous, which fixes non-contiguous
 * ordering (colorA, colorB, then colorA again).
 *
 * On a variant switch the page reloads to the new ?variant= URL, so the full
 * gallery is rebuilt and pruned fresh for the newly selected color.
 *
 * ALT RULE:
 *   - Variant-specific image  ->  ALT contains "Color: <value> |"
 *   - Shared (all variants)   ->  any other ALT, including empty
 *   IMPORTANT: every color photo must use "Color: <value> | ...". A photo left
 *   with an auto ALT like "... in Grey image 7" is treated as SHARED and will
 *   appear under every color.
 */
(function () {
  'use strict';

  var DEBUG = false;

  var MAIN_ITEM    = '.product__media-item';
  var THUMB_ITEM   = '.product__thumbs-item';
  var MAIN_SWIPER  = '.product__media-gallery-viewer';
  var THUMB_SWIPER = '.product__media-gallery-thumbails';
  var ALL          = '__all__';
  var RELOAD_ON_VARIANT_CHANGE = true;

  function norm(s) { return (s || '').toLowerCase().replace(/\s+/g, ' ').trim(); }

  function colorFromAlt(alt) {
    if (!alt) return ALL;
    var m = alt.match(/color\s*:\s*([^|]+?)\s*\|/i);
    return m ? norm(m[1]) : ALL;
  }

  function selectedColors() {
    var scopes = document.querySelectorAll(
      'variant-selects, variant-radios, product-variant-selects, form[action*="/cart/add"]'
    );
    var color = [], any = [];
    scopes.forEach(function (scope) {
      scope.querySelectorAll('input[type="radio"]:checked').forEach(function (r) {
        any.push(r.value);
        var n = String(r.name || '').toLowerCase();
        if (n.indexOf('color') !== -1 || n.indexOf('colour') !== -1) color.push(r.value);
      });
      scope.querySelectorAll('select').forEach(function (s) {
        if (!s.value) return;
        any.push(s.value);
        var n = String(s.name || '').toLowerCase();
        if (n.indexOf('color') !== -1 || n.indexOf('colour') !== -1) color.push(s.value);
      });
    });
    var chosen = color.length ? color : any;
    if (!chosen.length) {
      var json = document.querySelector('[data-selected-variant]');
      if (json && json.textContent.trim()) {
        try {
          var v = JSON.parse(json.textContent);
          ['option1', 'option2', 'option3'].forEach(function (k) { if (v[k]) chosen.push(v[k]); });
        } catch (e) {}
      }
    }
    var seen = {}, out = [];
    chosen.forEach(function (v) { var k = norm(v); if (v && !seen[k]) { seen[k] = 1; out.push(k); } });
    return out;
  }

  function shouldShow(item, selected) {
    var img = item.querySelector('img');
    var vc = colorFromAlt(img && img.getAttribute('alt'));
    return vc === ALL || selected.indexOf(vc) !== -1;
  }

  // Indexes (within the current node list) of items to remove.
  function removeIndexes(nodeList, selected) {
    var idx = [];
    for (var i = 0; i < nodeList.length; i++) if (!shouldShow(nodeList[i], selected)) idx.push(i);
    return idx;
  }

  function pruneGroup(swiperSelector, itemSelector, selected) {
    var el = document.querySelector(swiperSelector);
    var sw = el && el.swiper;
    var items = Array.prototype.slice.call(document.querySelectorAll(itemSelector));
    if (!items.length) return;

    var idx = removeIndexes(items, selected);
    if (!idx.length) return; // already clean -> no-op (prevents loops)

    if (sw && typeof sw.removeSlide === 'function') {
      try {
        sw.removeSlide(idx);   // Swiper removes the slide elements + updates
        sw.update();
      } catch (e) {
        // Fallback: remove nodes directly (descending order).
        idx.slice().reverse().forEach(function (i) { if (items[i]) items[i].remove(); });
      }
    } else {
      // No Swiper (e.g., desktop grid) -> remove the DOM nodes directly.
      idx.slice().reverse().forEach(function (i) { if (items[i]) items[i].remove(); });
    }
  }

  // Move the main viewer to the FIRST image of the selected color's group,
  // skipping any shared images that come before it.
  function focusFirstColor(selected) {
    var items = document.querySelectorAll(MAIN_ITEM);
    var target = 0;
    for (var i = 0; i < items.length; i++) {
      var img = items[i].querySelector('img');
      var vc = colorFromAlt(img && img.getAttribute('alt'));
      if (vc !== ALL && selected.indexOf(vc) !== -1) { target = i; break; }
    }
    var mainEl = document.querySelector(MAIN_SWIPER);
    if (mainEl && mainEl.swiper) { try { mainEl.swiper.slideTo(target, 0); } catch (e) {} }
    var thumbEl = document.querySelector(THUMB_SWIPER);
    if (thumbEl && thumbEl.swiper) { try { thumbEl.swiper.slideTo(target, 0); } catch (e) {} }
    if (DEBUG) console.log('[vif] focus first color slide index =', target);
  }

  function prune() {
    var selected = selectedColors();
    if (DEBUG) console.log('[vif] selected =', selected);
    if (!selected.length) return;
    pruneGroup(MAIN_SWIPER, MAIN_ITEM, selected);
    pruneGroup(THUMB_SWIPER, THUMB_ITEM, selected);
    focusFirstColor(selected);
    window.dispatchEvent(new Event('resize'));
  }

  // Prune a few times so we run once Swiper has initialised.
  function schedulePrune() {
    [0, 100, 250, 500, 900, 1400].forEach(function (ms) { setTimeout(prune, ms); });
  }

  // Re-prune if the full gallery ever gets (re)populated with other colors.
  if ('MutationObserver' in window) {
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var selected = selectedColors();
        if (!selected.length) return;
        var main = document.querySelectorAll(MAIN_ITEM);
        for (var i = 0; i < main.length; i++) if (!shouldShow(main[i], selected)) { prune(); return; }
      }, 80);
    }).observe(document.body, { childList: true, subtree: true });
  }

  // --- Reload on a real variant change (rebuilds gallery for the new color) --
  var reloadPending = false;
  function armReload() {
    if (!RELOAD_ON_VARIANT_CHANGE || reloadPending) return;
    reloadPending = true;
    var before = location.href;
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (location.href !== before) { clearInterval(iv); location.reload(); }
      else if (tries > 25) { clearInterval(iv); reloadPending = false; }
    }, 100);
  }

  document.addEventListener('change', function (e) {
    var t = e.target; if (!t) return;
    var n = String(t.name || '').toLowerCase();
    if (n.indexOf('color') !== -1 || n.indexOf('colour') !== -1 || n === 'id' ||
        (t.closest && t.closest('variant-selects, variant-radios, form[action*="/cart/add"]'))) armReload();
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest('variant-selects label, variant-radios label, [data-option-value], [data-value]')) armReload();
  });
  try {
    if (window.ThemeEvents && ThemeEvents.variantUpdate) document.addEventListener(ThemeEvents.variantUpdate, armReload);
  } catch (e) {}

  document.addEventListener('DOMContentLoaded', schedulePrune);
  schedulePrune();
})();